<template>
  <main-box-sc>
    <picker class="picker-wh" v-model="year" :init-options="getYears" @set-option="setOption" ></picker>
    <picker class="picker-wh" v-model="month" :init-options="initMonthObj" :reset-index="resetIndex" @set-option="setOption" @update-reset-index="updateResetIndex" ></picker>
    <picker class="picker-wh" v-model="day" :init-options="initDayObj" :reset-index="resetIndex" @set-option="setOption" @update-reset-index="updateResetIndex" ></picker>
    <picker class="picker-wh" v-model="hours" :init-options="initHoursObj" :reset-index="resetIndex" @set-option="setOption" @update-reset-index="updateResetIndex" ></picker>
<!--    <slot name="header"></slot>-->
    <button class="finish" @click="handleClickFinish">{{ $t("share.finish") }}</button>
  </main-box-sc>
</template>

<script>
import {MainBoxSc} from './datePickerSc';
import Picker from '../picker/Picker.vue';
import { ref, reactive, computed, onMounted } from 'vue';
import {useI18n} from 'vue-i18n';

const currentDate = new Date();

export default {
  name: 'DatePicker',
  components: {
    MainBoxSc,
    Picker
  },
  props: {
    modelValue: Date,
    type: {
      type: String,
      default: 'datetime',
    },
    minDate: {
      type: Date,
      default: () => new Date(currentDate.getFullYear(), 0, 1)
    },
    maxDate: {
      type: Date,
      default: () => new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate(), currentDate.getHours())
    },
  },
  setup(props, context) {
    const { t } = useI18n();
    let _minDate = new Date(props.minDate.getFullYear(),props.minDate.getMonth(),props.minDate.getDate(),props.minDate.getHours());
    let _maxDate = new Date(props.maxDate.getFullYear(),props.maxDate.getMonth(),props.maxDate.getDate(),props.maxDate.getHours());
    const updateValue = () => {
      context.emit('update:modelValue',new Date(year.value,month.value -1,day.value, hours.value));
    };

    let resetIndex = ref(false); //重置索引
    let year = ref(currentDate.getFullYear()); //所选年
    let month = ref(currentDate.getMonth() + 1); //所选月
    let day = ref(currentDate.getDate()); //所选日
    let hours = ref(currentDate.getHours()); //所选时
    //月份数据结构
    let initMonthObj = reactive({
      options: [],
      realOptions: [],
      flag: 'month'
    });
    //日份数据结构
    let initDayObj = reactive({
      options: [],
      realOptions: [],
      flag: 'day'
    });
    //时数数据结构
    let initHoursObj = reactive({
      options: [],
      realOptions: [],
      flag: 'hours'
    })
    onMounted(() => {
      if(props.modelValue instanceof Date){
        year.value = props.modelValue.getFullYear();
        month.value = props.modelValue.getMonth() +1;
        day.value = props.modelValue.getDate();
        hours.value = props.modelValue.getHours();
      }
    });
    /**
     * 获取年份信息
     */
    const getYears = computed( () => {
      let result = [];
      let _minYear = props.minDate.getFullYear();
      let _maxYear = props.maxDate.getFullYear();
      for(let i = _minYear -10;i < _maxYear + 10;i++){
        result.push(setDisabled(i, i));
      }
      return {
        options: result.map(s => s.value + t('share.year')),
        realOptions: result,
        flag: 'year'
      };
    });
    /**
     * 获取月份信息
     */
    const getMonths = (_val) => {
      _val = _val || year;
      let result = [];
      let months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      for(let i = 1;i <= months.length;i++){
        result.push(setDisabled(i, _val, i - 1));
      }
      initMonthObj.options = months.map(s => s + t('share.month'));
      initMonthObj.realOptions = result;
    };
    /**
     * 获取指定年月的日期
     * @param _year 年
     * @param _month 月
     */
    const getYearMonthDates = (_year, _month) => {
      if (!_year || !_month) {
        let _date = new Date();
        _year = _date.getFullYear();
        _month = _date.getMonth() + 1;
      }
      let result = [];
      //最后一天
      let lastOfMonth = new Date(_year, _month, 0);
      let lastDateOfMonth = lastOfMonth.getDate();
      for(let i = 1; i <= lastDateOfMonth; i++){
        result.push(setDisabled(i, _year, _month - 1, i));
      }
      initDayObj.options = result.map(s => s.value + t('share.dayPlus'));
      initDayObj.realOptions = result;
    };
    /**
     * 获取时数
     */
    const getHours = (_year, _month, _day) => {
      if (!_year || !_month || !_day) {
        let _date = new Date();
        _year = _date.getFullYear();
        _month = _date.getMonth() + 1;
        _day = _date.getDate();
      }
      let result = [];
      for(let i = 0; i < 24;i++){
        result.push(setDisabled(i, _year, _month -1, _day, i));
      }
      initHoursObj.options = result.map(s => s.value + t('share.hours'));
      initHoursObj.realOptions = result;
    }
    /**
     * 设置不可选
     * @param val 值
     * @param _year 年
     * @param _month 月
     * @param _day 日
     * @returns {{disabled: boolean, value}}
     */
    const setDisabled = (val, _year, _month, _day, _hours) => {
      _year = _year || currentDate.getFullYear();
      _month = _month === 0 ? _month : (_month || currentDate.getMonth());
      _day = _day || currentDate.getDate();
      _hours = _hours === 0 ? _hours : (_hours || currentDate.getHours());
      let _obj = {
        value: val,
        disabled: true
      };
      let _val = new Date(_year, _month, _day, _hours);
      if(_val >= _minDate && _val <= _maxDate){
        _obj.disabled = false;
      }
      return _obj;
    };
    /**
     * 设置日期
     * @param val 值
     * @param flag 标志
     */
    const setOption = (val, flag) => {
      if(flag === 'day'){
        getHours(year.value, month.value, val)
        resetIndex.value = true;
      }else if(flag === 'month'){
        getYearMonthDates(year.value, val);
        getHours(year.value, val, day.value)
        resetIndex.value = true;
      }else if(flag === 'year'){
        getHours(val, month.value, day.value)
        getMonths(val);
        getYearMonthDates(val, month.value);
        resetIndex.value = true;
      }
    };
    /**
     * 点击完成事件
     */
    const handleClickFinish = () => {
      updateValue();
      context.emit('handleClickFinish');
    };
    /**
     * 更新索引
     */
    const updateResetIndex = () => {
      resetIndex.value = false;
    };
    return{
      resetIndex,
      year,
      month,
      day,
      hours,
      initMonthObj,
      initDayObj,
      initHoursObj,
      getYears,
      setOption,
      handleClickFinish,
      updateResetIndex
    };
  }
};
</script>


<style scoped>

</style>